__turbopack_context__.v({
  "className": "plus_jakarta_sans_62d5f9d9-module__NlM06a__className",
  "variable": "plus_jakarta_sans_62d5f9d9-module__NlM06a__variable",
});
